import type { CourseLesson } from "src/components/Course/lessons/Lesson/RepetitionLesson";
import ExamDetails from "src/components/NewComponents/Views/Details/ExamDetails";
import { ExamTypes } from "src/types/enums";

interface WaitingDetailsProps {
	lesson: CourseLesson;
	className?: string;
}

export const WaitingDetails = ({ lesson, className }: WaitingDetailsProps) => {
	return (
		<ExamDetails
			className={className}
			row={{
				name: lesson.name,
				score: 0,
				totalQuestions: lesson.itemsIds.length,
				resolvedQuestions: 0,
				type: ExamTypes.COURSE,
				status: lesson.status,
			}}
		/>
	);
};
